// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__oMaiW","containerItemsCenter":"Skeleton_containerItemsCenter__3Vjt9"};